// Updated to serve static data after the campaign ended.

import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Poll.scss';
import Q1AnswerCopy from './Q1AnswerCopy';
import Q2AnswerCopy from './Q2AnswerCopy';
import Q3AnswerCopy from './Q3AnswerCopy';
// import axios from 'axios';

function Poll({ pollQuestions }) {
  const answerContainer = useRef();
  const questionContainer = useRef();
  const answeredBar1 = useRef();
  const answeredBar2 = useRef();
  const columnRef = useRef();
  const [choice1, setChoice1] = useState();
  const [choice2, setChoice2] = useState();
  const [choice1Percentage, setChoice1Percentage] = useState();
  const [choice2Percentage, setChoice2Percentage] = useState();
  const [view, setView] = useState('question');
  // columnRef.current = [
  //   ['A1', 'A2'],
  //   ['B1', 'B2'],
  //   ['C1', 'C2']
  // ];
  columnRef.current = [
    [69, 32],
    [31, 57],
    [19, 16]
  ];

  const calculatePercentage = (c1, c2) => {
    let total = c1 + c2;
    let c1P = Math.round((c1 / total) * 100);
    let c2P = Math.round((c2 / total) * 100);
    setChoice1(c1);
    setChoice2(c2);
    setChoice1Percentage(c1P);
    setChoice2Percentage(c2P);
  };

  const addDataToDynamoDB = (answer) => {
    let ch1 = columnRef.current[pollQuestions.index][0];
    let ch2 = columnRef.current[pollQuestions.index][1];
    answer === 'choice1' ? (ch1 += 1) : (ch2 += 1);
    calculatePercentage(ch1, ch2);
  };
  // const addDataToDynamoDB = (answer) => {
  //   const ch1 = columnRef.current[pollQuestions.index][0];
  //   const ch2 = columnRef.current[pollQuestions.index][1];

  //   const data = {
  //     ExpressionAttributeNames: {
  //       '#AT': `${answer === 'choice1' ? ch1 : ch2}`
  //     },
  //     ExpressionAttributeValues: {
  //       ':num': {
  //         N: '1'
  //       }
  //     },
  //     Key: {
  //       campaign: {
  //         S: 'pfizer-eczema'
  //       }
  //     },
  //     ReturnValues: 'ALL_NEW',
  //     TableName: 'pollTest',
  //     UpdateExpression: 'SET #AT = #AT + :num'
  //   };
  //   const config = {
  //     method: 'patch',
  //     url: `https://p3mo1vr1zh.execute-api.us-east-1.amazonaws.com/production/pollTest`,
  //     data: data
  //   };

  //   axios(config)
  //     .then(function (response) {
  //       const currentQ = response.data.Attributes;
  //       const currentChoice1 = +currentQ[ch1]['N'];
  //       const currentChoice2 = +currentQ[ch2]['N'];
  //       calculatePercentage(currentChoice1, currentChoice2);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  const showResult = useCallback(
    (view) => {
      if (view === 'question') {
        questionContainer.current.style.visibility = 'visible';
        questionContainer.current.style.opacity = '1';
        answerContainer.current.style.visibility = 'hidden';
        answerContainer.current.style.opacity = '0';
      } else {
        questionContainer.current.style.visibility = 'hidden';
        questionContainer.current.style.opacity = '0';
        setTimeout(() => {
          answerContainer.current.style.visibility = 'visible';
          answerContainer.current.style.opacity = '1';
          if (answeredBar1.current) {
            answeredBar1.current.style.width = `${choice1Percentage}%`;
            answeredBar2.current.style.width = `${choice2Percentage}%`;
          }
        }, 1000);
      }
    },
    [choice1Percentage, choice2Percentage]
  );

  useEffect(() => {
    showResult(view);
  }, [view, showResult]);

  return (
    <section className="container">
      <div className="content">
        <div className="poll" ref={questionContainer}>
          <p className="poll__question">
            {pollQuestions.qCopy}
            <sup className="poll__question--sup">{pollQuestions.sup}</sup>
          </p>
          <div className="poll__answer">
            <div
              className="poll__choice poll--choice1"
              onClick={() => {
                setView('answer');
                addDataToDynamoDB('choice1');
                showResult();
              }}
            >
              <p className="poll__choice-text ">
                {pollQuestions.choice1}
                <sup className="poll__choice-sb">%</sup>
              </p>
            </div>
            <div
              className="poll__choice poll--choice2"
              onClick={() => {
                setView('answer');
                addDataToDynamoDB('choice2');
                showResult();
              }}
            >
              <p className="poll__choice-text">
                {pollQuestions.choice2}
                <sup className="poll__choice-sb">%</sup>
              </p>
            </div>
          </div>
        </div>

        <div className="poll poll--answered" ref={answerContainer}>
          {pollQuestions.index === 0 ? <Q1AnswerCopy pollQuestions={pollQuestions} /> : <></>}
          {pollQuestions.index === 1 ? <Q2AnswerCopy pollQuestions={pollQuestions} /> : <></>}
          {pollQuestions.index === 2 ? <Q3AnswerCopy pollQuestions={pollQuestions} /> : <></>}

          <div className="poll__answer poll__answer--answered">
            {choice1Percentage > 17 ? (
              <div className="poll__choice--answered poll__choice--answered--choice1">
                <div className="poll__choice--answered-filled  poll--choice1" ref={answeredBar1} />
                <div className="poll__choice--text--answered">
                  <p className="poll__choice--text--percent">{choice1Percentage}%</p>
                  {choice1Percentage <= 30 ? (
                    <p className="poll__choice--text--selected">
                      Selected
                      <br />
                      {pollQuestions.choice1}%
                    </p>
                  ) : (
                    <p className="poll__choice--text--selected">
                      Selected {pollQuestions.choice1}%
                    </p>
                  )}
                </div>
              </div>
            ) : (
              <div className="poll__choice--answered poll__choice--answered--choice1 choice1 ">
                <div className="poll__choice--text--answered  poll__choice--text--answered--small">
                  <p className="poll__choice--text--percent">{choice1Percentage}%</p>
                  <p className="poll__choice--text--selected">Selected {pollQuestions.choice1}%</p>
                </div>
                <div className="poll__choice--answered-filled  poll--choice1" ref={answeredBar1} />
              </div>
            )}

            <div className="poll__choice--answered poll__choice--answered--choice2">
              {choice2Percentage > 17 ? (
                <>
                  <div
                    className="poll__choice--answered-filled  poll--choice2"
                    ref={answeredBar2}
                  />
                  <div className="poll__choice--text--answered">
                    <p className="poll__choice--text--percent">{choice2Percentage}%</p>
                    {choice2Percentage <= 30 ? (
                      <p className="poll__choice--text--selected">
                        Selected
                        <br />
                        {pollQuestions.choice2}%
                      </p>
                    ) : (
                      <p className="poll__choice--text--selected">
                        Selected {pollQuestions.choice2}%
                      </p>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="poll__choice--answered-filled  poll--choice2"
                    ref={answeredBar2}
                  />
                  <div className="poll__choice--text--answered poll__choice--text--answered--small choice2">
                    <p className="poll__choice--text--percent">{choice2Percentage}%</p>
                    <p className="poll__choice--text--selected">
                      Selected {pollQuestions.choice2}%
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Poll;
